// src/components/SetupAdminScreen.js
import React, { useState } from "react";
import { useAuth, ADMIN_SEED_CPF } from "../context/AuthContext"; // Importe o ADMIN_SEED_CPF
import { Button } from "./Button";

export const SetupAdminScreen = () => {
  const { createAdminUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreateAdmin = async () => {
    setLoading(true);
    setError('');
    const success = await createAdminUser();
    if (!success) {
      setError("Falha ao criar o administrador. Verifique o console ou as permissões do Firebase.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="max-w-md w-full bg-white rounded-lg shadow-2xl p-8 m-4 text-center">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">SIAAP - Setup</h2>
        <p className="text-center text-gray-600 mb-6">
          O usuário Administrador Mestre (CPF: {ADMIN_SEED_CPF}) não foi encontrado.
        </p>
        <p className="text-sm text-gray-600 mb-6">
          Isto é normal na primeira execução. Clique no botão abaixo para criar este usuário
          e iniciar o sistema.
        </p>

        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <Button onClick={handleCreateAdmin} variant="success" disabled={loading} className="w-full">
          {loading ? "Criando Admin..." : "Criar Admin Mestre e Entrar"}
        </Button>
      </div>
    </div>
  );
};